import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { store } from './app/store/store';
import { Provider } from 'react-redux';
import { AlertProvider, SystemNotificationProvider } from 'app/common/providers';
import 'resources/i18n';
import { BrowserRouter } from 'react-router-dom';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <AlertProvider>
      <SystemNotificationProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SystemNotificationProvider>
    </AlertProvider>
  </Provider>,
);

reportWebVitals();
